import React from 'react';
import { Button } from 'semantic-ui-react';
var defaultProps = {
  checkoutDisabled: false
};
var QuantitySelector = function QuantitySelector(_ref) {
  var quantity = _ref.quantity,
    onQuantityChange = _ref.onQuantityChange,
    checkoutDisabled = _ref.checkoutDisabled;
  return /*#__PURE__*/React.createElement(Button.Group, {
    inverted: true
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: quantity === 1 || checkoutDisabled,
    onClick: function onClick() {
      return onQuantityChange(-1);
    },
    icon: {
      name: 'minus',
      color: 'black'
    }
  }), /*#__PURE__*/React.createElement(Button, {
    disabled: checkoutDisabled
  }, quantity), /*#__PURE__*/React.createElement(Button, {
    disabled: checkoutDisabled,
    onClick: function onClick() {
      return onQuantityChange(1);
    },
    icon: {
      name: 'plus',
      color: 'black'
    }
  }));
};
QuantitySelector.defaultProps = defaultProps;
export default QuantitySelector;